import React, { useState, useEffect } from 'react';
import {Row, Col, FloatingLabel , Form} from 'react-bootstrap'
import { ToastContainer, toast } from "react-toastify";

import UserLogin from '../../dist/images/user-login.png'
import UserIcon from '../../dist/images/icons/user.png'
import PasswordIcon from '../../dist/images/icons/password.png'

const mockUsers = [
  { username: "admin", password: "pass123" },
  { username: "user2", password: "secure456" },
  { username: "user3", password: "mypassword" }
];

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({})

  const validation = () => {
    let errors ={}
    if(!username.trim()){
      errors.username = "Username is required"
    }
    if(!password.trim()){
      errors.password = "Password is required"
    }
    return errors
  }

  const handleDemoLoginChange = () => {
    setUsername('admin')
    setPassword('pass123')
    setErrors({})
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationForm = validation()

    if(Object.keys(validationForm).length > 0){
      setErrors(validationForm)
    } else {
      const user = mockUsers.find(u => u.username === username && u.password === password);
      if (user) {
        toast.success("Login Successfully")
        setTimeout(() => {
          onLogin(user.username);
        }, 1500)       
        
      } else {
        toast.error("Invalid Username or Password")
      }
    }    
  };

  return (
    <div>
      <Row className="m-0 login-wrapper">
        <Col className="login-form-container">
          <div className="auth-form">
          <h1 className="text-center mb-5">Welcome Back!!</h1>
          <form onSubmit={handleSubmit}>
            <div className="login-input-grp">
              <div className="login-input">

              <label>Username</label>
              <img src={UserIcon} width="20" />
              <input type="text" placeholder="Username" value={username} 
                onChange={(e) => {setUsername(e.target.value); errors.username = ''}} 
               />
               </div>
             {errors.username && <span className="errors ps-3">{errors.username}</span>}
           </div>
           
           <div className="login-input-grp">
             <div className="login-input">
              <label>Password</label>
              <img src={PasswordIcon} width="20" />
              <input type="password" placeholder="Password" value={password} 
                onChange={(e) => {setPassword(e.target.value); errors.password = ''}  }
              />
             </div>
           {errors.password && <span className="errors ps-3">{errors.password}</span>}
           </div>

           <p onClick={handleDemoLoginChange} className="text-end opacity-50 curser-pointer"><small>Demo Login?</small></p>
            
            
            <button className="login-btn" type="submit">Login</button>
          </form>
          </div>
          </Col>
          <Col md={6} className="login-image-container">
            <img src={UserLogin} />          
          </Col>
      </Row>
       <ToastContainer position="top-right" autoClose={1500} />
    </div>
  );
};

export default Login;